export const BACK = 27;
export const PLAY_PAUSE = 179;
export const REWIND = 227;
export const FAST_FORWARD = 228;
